var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.total > 0,
          expression: "total > 0",
        },
      ],
      staticClass: "show-items-label",
    },
    [
      _c("div", [
        _vm._v(" Показано "),
        _c("b", [_vm._v(_vm._s(_vm.count))]),
        _vm._v(" из "),
        _c("b", [_vm._v(_vm._s(_vm.total))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }